import GSAP from 'gsap';
import Component from '@averyano/core/src/classes/Component';

export default class PopupComponent extends Component {
	constructor({ element, elements }) {
		super({
			element: element,
			elements: {
				wrapper: '.popup__wrapper',
				cross: '.popup__cross',
				bg: '.popup__background',
				...elements,
			},
		});

		this.isOpen = false;
	}

	create() {
		this.addEventListeners();
	}

	show() {
		this.isOpen = true;
		GSAP.set(this.element, { autoAlpha: 1 });
	}

	hide() {
		this.isOpen = false;
		GSAP.set(this.element, { autoAlpha: 0 });
	}

	addEventListeners() {
		if (this.elements.cross)
			this.elements.cross.addEventListener('click', this.hide.bind(this));
		this.elements.bg.addEventListener('click', this.hide.bind(this));
		window.addEventListener('keydown', (e) => {
			if (e.key === 'Escape' && this.isOpen) {
				this.hide();
			}
		});
	}
}
